<template>
  <div id="pricingResult">
    <div class="logo">
      <img src="../../assets/img/ic-ok-sign.png">
    </div>
    <h1>결제가 완료되었습니다</h1>
    <div class="container">
      <div class="row">
        <div class="col-md-offset-4 col-md-4">
          <!-- 상품정보 -->
          <div class="receipt-box margin-bottom-32">
            <h4>상품정보</h4>
            <div class="detail">
              <div class="form-group">
                <div class="col-xs-6">
                  <label>상품명</label>
                </div>
                <div class="col-xs-6">
                  <p>{{ payInfo.product_nm | nullCheck }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 결제정보 -->
          <div class="receipt-box border-bottom">
            <h4>결제정보</h4>
            <div class="detail">
              <div class="form-group">
                <div class="col-xs-6">
                  <label>이용요금</label>
                </div>
                <div class="col-xs-6">
                  <p>{{ serviceFee | intcomma }} 원</p>
                </div>
              </div>
              <div class="form-group border-bottom">
                <div class="col-xs-6">
                  <label>부가세</label>
                </div>
                <div class="col-xs-6">
                  <p>{{ serviceVat | intcomma }} 원</p>
                </div>
              </div>
              <div class="form-group margin-bottom-24">
                <div class="col-xs-6">
                  <label>총 결제금액</label>
                </div>
                <div class="col-xs-6">
                  <p class="amount">{{ payInfo.amount | intcomma }} 원</p>
                </div>
              </div>
              <div class="form-group">
                <div class="col-xs-6">
                  <label>결제카드</label>
                </div>
                <div class="col-xs-6">
                  <p>{{ payInfo.acquirer_nm | nullCheck }}</p>
                </div>
              </div>
              <div class="form-group">
                <div class="col-xs-6">
                  <label>카드정보</label>
                </div>
                <div class="col-xs-6">
                  <p>{{ payInfo.card_no | nullCheck }}</p>
                </div>
              </div>
              <div class="form-group">
                <div class="col-xs-6">
                  <label>할부개월</label>
                </div>
                <div class="col-xs-6">
                  <p>{{ installPeriod | nullCheck }}</p>
                </div>
              </div>
              <div class="form-group margin-bottom-8">
                <div class="col-xs-6">
                  <label>승인일시</label>
                </div>
                <div class="col-xs-6">
                  <p>{{ payInfo.tran_date | nullCheck }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 안내문구 -->
          <p class="description">
            결제내역은 <router-link :to="{name: 'mycoupon'}" class="link">이용권관리/쿠폰함</router-link> 메뉴에서 확인하실 수 있습니다. <br />
            문의사항 및 도움이 필요하시면 <br />
            <router-link :to="{name: 'cscenter'}" class="link" @click.prevent="">고객센터>제휴/문의</router-link>에서 문의 부탁드립니다. <br />
          </p>
          <div class="text-center">
            <button type="button" class="hz-btn-primary hz-btn-lg" style="width: 167px;" @click="$router.push('/')">확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  'use strict'

  export default {
    name: 'pricing-result',
    data: function () {
      return {
        payInfo: {},
        dummyPayInfo: {
          cash_auth_type: '',
          order_no: 'BIZ-201912301655-43',
          cpon_no: '',
          install_period: '00',
          bank_cd: '',
          mobile_no: '',
          canc_date: '',
          account_no: '',
          pay_type: '11',
          res_cd: '0000',
          service: 'biz',
          source: '',
          ars_no: '',
          bk_pay_yn: 'N',
          cpon_tran_date: '',
          escrow_yn: 'N',
          card_no: '4364-****-****-5293',
          canc_acq_date: '',
          used_cpon: '',
          acquirer_nm: 'Payzone TestCard',
          billid: '',
          mall_id: '',
          part_cancel_yn: 'Y',
          cash_issue_type: '',
          res_msg: '결제가 성공적으로 완료되었습니다.',
          issuer_cd: '049',
          cp_cd: '',
          cpon_auth_no: '',
          refund_date: '',
          card_biz_gubun: 'P',
          cash_res_cd: '',
          auth_id: '',
          auth_no: '00005399',
          acquirer_cd: '026',
          complex_yn: 'N',
          expire_date: '',
          deposit_nm: '',
          cno: '19123016555010602304',
          bank_nm: '',
          card_gubun: 'N',
          tran_date: '2019-12-30 16:57:35',
          cash_res_msg: '',
          noint: '00',
          rem_amt: '',
          cash_tran_date: '',
          cpon_flag: 'N',
          cash_auth_no: '',
          issuer_nm: 'OK:00005399',
          mob_ansim_yn: '',
          stat_msg: '매입요청',
          remain_cpon: '',
          stat_cd: 'TS03',
          amount: '150000',
          cash_auth_value: ''
        }
      }
    },
    computed: {
      serviceFee () {
        // 부가세를 제외한 결제요금 90%를 반환한다.
        const amount = this.payInfo.amount

        return amount ? amount * 0.9 : '-'
      },
      serviceVat () {
        // 부가세 10%를 반환한다.
        const amount = this.payInfo.amount

        return amount ? amount * 0.1 : '-'
      },
      installPeriod () {
        // 할부개월을 반환한다.
        const installPeriod = this.payInfo.install_period

        return installPeriod === '00' ? '일시불' : installPeriod
      }
    },
    created: function () {
      const params = this.$route.params
      const isEmptyParams = $.isEmptyObject(params)

      if (isEmptyParams) {
        this.$router.push({name: 'pricing'})
        return false
      }

      this.payInfo = params
    }
  }
</script>

<style lang="scss" scoped>
  #pricingResult {
    padding: 111px 0 90px 0;
    word-break: keep-all;

    .logo {
      text-align: center;
      margin-bottom: 24px;

      img {
        width: 32px;
        height: 32px
      }
    }

    h1 {
      margin: 0 0 40px 0;
      font-size: 40px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: -2.42px;
      text-align: center;
      color: $header-color;
    }

    .receipt-box {
      h4 {
        margin: 0 0 8px 0;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        letter-spacing: -0.8px;
        color: $header-color;
        border-bottom: 1px solid #343a40;
      }

      .detail {
        .form-group {
          margin: 0;
          padding: 8px 0;
          overflow: auto;
        }

        .col-xs-6 { padding:  0; }

        label, p {
          margin: 0;
          font-size: 14px;
          font-stretch: normal;
          font-style: normal;
        }

        label {
          line-height: 1.43;
          letter-spacing: -0.35px;
          color: $font-color;
        }

        p {
          line-height: 1.57;
          letter-spacing: -0.58px;
          text-align: right;
          color: $hzc-gray-06;
        }

        .amount {
          font-weight: bold;
          color: $font-color;
        }
      }
    }

    .description {
      margin: 0 0 24px 0;
      padding: 16px 0;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: -0.3px;
      color: #868e96;

      .link {
        color: #868e96;
        text-decoration: underline;
      }
    }

    .border-bottom {
      border-bottom: 1px solid $hzc-gray-05;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pricing/PricingResult.vue